import { render, staticRenderFns } from "./learningMaterials.vue?vue&type=template&id=3fe7c590&scoped=true&"
import script from "./learningMaterials.vue?vue&type=script&lang=js&"
export * from "./learningMaterials.vue?vue&type=script&lang=js&"
import style0 from "./learningMaterials.vue?vue&type=style&index=0&id=3fe7c590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7c590",
  null
  
)

export default component.exports